export function setWaitlist(state, payload) {
  state.waitlist = payload;
}

export function addToWaitlist(state, payload) {
  state.waitlist.data.push(payload);
}

export function updateIsWaitlistDataLoaded(state, payload) {
  state.isWaitlistDataLoaded = payload;
}

export function setWaitlistDropInCoachingSessionDialog(state, props) {
  state.waitlistRegistrationDialog = props;
}
export function setWaitlistDropInCoachingSlot(state, props) {
  state.waitlistDropInCoachingSlot = props;
}

export function setWaitlistDropInType(state, props) {
  state.waitlistDropInType = props;
}
